import {Component, OnInit} from '@angular/core';
import { AuthService } from './services/auth/auth.service';

@Component({
  selector: 'app-root',
  template: `<router-outlet></router-outlet>`,
  styleUrls: ['./app.component.css']
})

export class AppComponent implements OnInit {
  title = 'EMR';
  constructor(private authService: AuthService) {
  }
  public ngOnInit(): void {
    this.authService.handleAuthentication();
  }
}
